// client/src/contexts/SettingsContext.js
import { createContext, useState, useEffect } from 'react';
import settingsService from '../services/settingsService.js';

export const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    settingsService.getPublicSettings()
      .then((data) => {
        setSettings(data.settings || {});
        setUserTypes(data.userTypes || []);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, userTypes, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export default SettingsContext;